import {
  AddressInfo, CivilState, ExtraFieldValues, TypeAdresse,
} from '../types';

const ADDRESS_TYPE_PAYLOAD: Record<TypeAdresse, string | null> = {
  domicile: 'own_home',
  heberge: 'hosted',
  '': null,
};

// The API boundary between the ANTS form's French field names/values and the order PATCH's English
// ones (backend-plan.md §7.2) — kept out of DemarcheFunnelStore, same reasoning as contactMapping.ts.
const mapAnswersToOrderPayload = (
  civilState: CivilState, address: AddressInfo, extraFieldValues: ExtraFieldValues,
) => ({
  nationality: civilState.nationalite,
  birth_date: civilState.dateNaissance,
  birth_city: civilState.villeNaissance,
  birth_country: civilState.paysNaissance,
  street: address.adresse,
  street_extra: address.complement,
  postal_code: address.cp,
  city: address.ville,
  address_type: ADDRESS_TYPE_PAYLOAD[address.typeAdresse],
  extra_field_values: extraFieldValues,
});

export { mapAnswersToOrderPayload };
